import * as DTOS from "../../../FeralScan.dtos";
import * as H from 'history';

export const enum RoutePermission {
    LOGGED_IN_ONLY = "LOGGED_IN_ONLY",
    LOGGED_OUT_ONLY = "LOGGED_OUT_ONLY"
}

export const enum UserRole {
    ADMIN = "Admin",
}

export const PAGE_TYPE = "PAGE";
export const LINK_TYPE = "LINK";

export type PageConfig = IPageConfig | ILinkConfig;

export interface IPageConfig<ConfigurationProps = any> extends ICommonConfig {
    component: any;
    configurationProps?: ConfigurationProps;
    route: string[];
    type: typeof PAGE_TYPE;

    routePermission?: RoutePermission;
    routePermissionRedirectTo?: string;
    routeRole?: UserRole;

    generateSideBar?: boolean;
    generateLegendFindings?: boolean;
    generateLegendSiteSelect?: boolean;
}

export interface ILinkConfig extends ICommonConfig {
    type: typeof LINK_TYPE;
    link?: string;
    route?: string;
}

interface ICommonConfig {
    name: string;
    icon?: string;
    generateNav: boolean;
    generateNavIfHasRole?: UserRole;
    generateNavIfLoggedIn?: boolean;
}

export interface IPageGroupConfig {
    name: string;
    classification?: string;
    classificationRoute?: string;
    pageLayout: IPageLayout; 
    pages: PageConfig[];
    theme: string;
}

export type Params<T extends { [index: string]: any }> = {
    [index in keyof T]: string;
}

export interface IBasePageProps<RouteParams extends Params<RouteParams> = any, QueryParams extends Params<QueryParams> = any> {
    currentUser: DTOS.User;
    currentUserLoading: boolean;
    defaultDateFormat: "DD/MM/YYYY" | "DD MMM YYYY";
    defaultDateTimeFormat: "DD/MM/YYYY hh:mm a" | "DD MMM YYYY hh:mm a",
    history: H.History;
    location: Location;
    loginActive: boolean;
    queryParams: QueryParams;
    routeParams: RouteParams;
    setUserPreference: (key: string, value: string) => void;
    websiteSettings: DTOS.WebsiteSettings;
}

export interface IPageLayout {
    component: any;
}

export interface IPageLayoutProps {
    currentUser: DTOS.User;
    loginActive: boolean;
    pages?: PageConfig[];
    theme?: any;

    websiteSettings: DTOS.WebsiteSettings;
    // these generate props should be refactored out
    generateSideBar: boolean;
    generateLegendFindings: boolean;
    generateLegendSiteSelect: boolean;
}

export interface IClassification {
    name: string;
}

export interface IChartConfig {
    defaultFontColor: string;
    defaultFontSize: number;
}

export interface IFrameworkConfig {
    chartsConfig: IChartConfig;
    defaultDateFormat: "DD/MM/YYYY" | "DD MMM YYYY";
    defaultDateTimeFormat: "DD/MM/YYYY hh:mm a" | "DD MMM YYYY hh:mm a",
    defaultDocumentTitle: string;
    defaultRoute: string;
    defaultLoginSuccessRoute: string;
    plotBadgeComponent: any;
}

export enum PlatypusPlotStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    EVALUATING = "EVALUATING"
}

export enum FeralScanPlotStatus {
}